var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import HeaderCell from './HeaderCell';
import { Checkbox } from '@mui/material';
var Thead = /** @class */ (function (_super) {
    __extends(Thead, _super);
    function Thead(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isResizing: false
        };
        _this.handleStartResize = _this.handleStartResize.bind(_this);
        _this.handleStopResize = _this.handleStopResize.bind(_this);
        return _this;
    }
    Thead.prototype.handleStartResize = function () {
        this.setState({ isResizing: true });
    };
    Thead.prototype.handleStopResize = function () {
        this.setState({ isResizing: false });
    };
    Thead.prototype.render = function () {
        var _this = this;
        var _a = this.props, columns = _a.columns, sortAction = _a.sortAction, columnDropAction = _a.columnDropAction, resizeAction = _a.resizeAction, filterFactory = _a.filterFactory, resizable = _a.resizable, draggable = _a.draggable, rowSelectionManager = _a.rowSelectionManager;
        return (React.createElement("thead", null,
            React.createElement("tr", null,
                rowSelectionManager.isEnabled && React.createElement("th", { className: "accDataTable__checkboxCell" }),
                columns.map(function (c, index) {
                    return (React.createElement(HeaderCell, { index: c.index, key: c.name, name: c.name, label: c.label, sort: c.sort, sortable: c.sortable, sortAction: sortAction, columnDropAction: columnDropAction, resizable: resizable, draggable: draggable, width: c.width, icon: c.icon, isResizing: !!_this.state.isResizing, onStartResize: function () { return _this.setState({ isResizing: true }); }, onStopResize: function () { return _this.setState({ isResizing: false }); }, handleResize: function (deltaResize) { return resizeAction(index, deltaResize); } }));
                })),
            React.createElement("tr", { className: "filters" },
                rowSelectionManager.isEnabled && React.createElement("td", { className: "accDataTable__checkboxCell", onClick: rowSelectionManager.onParentClick },
                    React.createElement(Checkbox, { checked: rowSelectionManager.isMainCheckboxChecked, indeterminate: rowSelectionManager.isMainCheckboxIndeterminate, onChange: rowSelectionManager.onMainCheckboxChange })),
                columns.map(function (c) { return React.createElement("td", { style: { width: c.width }, key: c.name }, filterFactory(c)); }))));
    };
    return Thead;
}(React.Component));
export default Thead;
//# sourceMappingURL=Thead.js.map